import { cn } from "@/lib/utils"

export interface SegmentedOption<T extends string> {
  value: T
  label: string
  disabled?: boolean
  title?: string
}

/**
 * Переключатель периода из образца (`Custom | 1D | 7D | 30D | 3M | 12M`).
 * Сделан на радиогруппе, а не на наборе кнопок: значение одно из списка, и
 * стрелками по нему должно ходить так же, как мышью.
 */
export function Segmented<T extends string>({
  options,
  value,
  onChange,
  label,
  className,
}: {
  options: ReadonlyArray<SegmentedOption<T>>
  value: T
  onChange: (value: T) => void
  label: string
  className?: string
}) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className={cn(
        "inline-flex items-stretch overflow-hidden rounded border border-line-strong bg-surface shadow-panel",
        className,
      )}
    >
      {options.map((option) => {
        const selected = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={option.disabled}
            title={option.title}
            onClick={() => onChange(option.value)}
            className={cn(
              "border-l border-line px-2.5 py-1 text-[13px] font-medium transition-colors duration-150 ease-snap first:border-l-0",
              selected
                ? "bg-accent text-accent-fg"
                : "text-fg-muted hover:bg-surface-sunken hover:text-fg",
              option.disabled && "cursor-not-allowed opacity-45 hover:bg-transparent hover:text-fg-muted",
            )}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
